import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=9c013538&"
import script from "./Building.vue?vue&type=script&lang=js&"
export * from "./Building.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c013538')) {
      api.createRecord('9c013538', component.options)
    } else {
      api.reload('9c013538', component.options)
    }
    module.hot.accept("./Building.vue?vue&type=template&id=9c013538&", function () {
      api.rerender('9c013538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Onboarding/Components/Building.vue"
export default component.exports